<div class="row chat-wrapper">
  <div class="col-md-12">
    <div class="card whatchat">
      <div class="card-body p-0">
        <div class="row">
          <div class="col-lg-12 chat-content d-block">

            <!-- users -->
            <div class="chat-header border-bottom pb-2" style="background: #e1ebf5;">
              <div class="d-flex justify-content-between">

                <!-- Member -->
                <div class="d-flex align-items-center friend">
                  <figure class="mb-0 me-2">
                    <p-avatar image="assets/images/advertiser.png" shape="circle" size="large"></p-avatar>
                  </figure>
                  <div id="profile-advertiser">
                    <p class="text-advertiser fw-bolder">
                      <span translate>Me</span>
                    </p>
                    <span class="badge badge-advertiser tx-13" translate>Member</span>
                  </div>
                </div>

                <!-- Support -->
                <div class="d-flex align-items-center me">
                  <div id="profile-publisher">
                    <p style="font-weight: 900">
                      <span>NETLINKDEAL</span>
                    </p>
                    <span class="badge badge-support tx-13" translate>Support</span>
                  </div>
                  <figure class="mb-0 ms-2">
                    <p-avatar image="assets/images/netlinkdeal.png" shape="circle" size="xlarge"></p-avatar>
                  </figure>
                </div>

              </div>
            </div>

            <!-- messages -->
            <div class="chat-body" [perfectScrollbar] #scrollMe [scrollTop]="scrollToEnd(scrollMe)">
              
              <ul class="messages">

                <!-- all messages -->
                <li class="message-item {{message.author == 'me'? 'me' : 'friend'}}" *ngFor="let message of messages">
                  <div class="content {{message.author == 'me'? 'me-5' : 'ms-5'}}">
                    <div class="message">
                      <div class="bubble" [ngClass]="{'tea': loading==true && message==messages[messages.length-1]}">
                        <div class="message-content">{{message.content}}</div>
                      </div>
                      <span [hidden]="message==messages[messages.length-1]">{{message.created_at | date : 'short'}}</span>
                      <span [hidden]="message!=messages[messages.length-1]">
                        <span *ngIf="loading==true" translate>Sending...</span>
                        <span *ngIf="loading!=true">{{message.created_at | date : 'short'}}</span>
                      </span>
                    </div>
                  </div>
                </li>

              </ul>
            </div>

            <!-- action -->
            <div class="chat-footer d-flex">
              <form class="search-form flex-grow-1 me-2">
                <div class="input-group">
                  <textarea #messageContent id="chatForm" autocomplete="off" name="chatForm"
                      class="form-control" [(ngModel)]="newMessage"
                      [ngModelOptions]="{standalone: true}" placeholder="{{'Type a message' | translate}}"
                      appTextareaAutoresize>
                  </textarea>
                </div>
              </form>
              <div>
                <button type="button" class="btn btn-primary btn-icon rounded-circle" (click)="addMessage(newMessage)" [disabled]="submitted==true || newMessage == ''">
                  <i class="feather icon-send"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>